import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";
import BaseController from "./BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";
import { EnvironmentService } from "../service/Environment.service";
import { ErrorHandler } from "../service/ErrorHandler.service";

/**
 * @namespace com.unitrade.crm.controller
 */
export default class Beleg extends BaseController {
  private _oModel: JSONModel;

  onInit(): void {
    this._oModel = new JSONModel();
    this.setModel(this._oModel, "model");
    const oOwnerComponent = this.getOwnerComponent();
    const oRouter = oOwnerComponent.getRouter();
    oRouter.getRoute("beleg").attachPatternMatched(this._onPatternMatch);
  }
  private _onPatternMatch = async (oEvent: Route$PatternMatchedEvent) => {
    const args = oEvent.getParameter("arguments") as {
      artPath: string;
      idPath: string;
    };
    const art = args.artPath.toUpperCase();
    const id = Number(args.idPath);

    this._oModel.setProperty("/art", art);
    this._oModel.setProperty("/id", id);

    try {
      this._oModel.setProperty("/busy", true);
      const belegkopf = await $.get(`${EnvironmentService.getBaseUrl()}/beleg/${art}/${id}`);
      this._oModel.setProperty("/belegkopf", belegkopf);
    } catch (ex: any) {
      ErrorHandler.handleError(ex, { message: "Fehler beim Laden des Belegkopfs" });
    } finally {
      this._oModel.setProperty("/busy", false);
    }
  };

  onExit(): void {
    const oOwnerComponent = this.getOwnerComponent();
    const oRouter = oOwnerComponent.getRouter();
    oRouter.getRoute("beleg").detachPatternMatched(this._onPatternMatch);
  }
}
